export class PrintRequest {
    public idEpisode: number | null = null;
    public ticketSequence: number | null = null;

    public healthUnitName: string = '';
    public patientName: string = '';
    public ticketInitials: string = '';
    public totemButtonName: string = '';
    public printerName: string = '';
    public qrCodeImage: string = '';

    public ticketGenerationDate: Date | null = null;
}